import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './DesktopFilters.styles';
import { DesktopFilterSelectAccordion } from './DesktopFilterSelectAccordion';
import { Region } from '@/api/types/regions.types';
import { QUERY } from '@/constants/common';
import { SearchResultsPageTestIds } from '@/__e2e__/testIds/search-results-page';
import { FilterSelectOption } from '@/components/Filters/helpers.types';

interface Props {
  currentRegion: Region | null;
  regions?: Region[];
  isLoading?: boolean;
}

export const RegionDesktopFilter: FC<Props> = ({
  currentRegion,
  regions = [],
  isLoading,
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');

  const { region: regionTestId, regionOption: regionOptionTestId } =
    SearchResultsPageTestIds.desktopFilters;
  const options: FilterSelectOption[] = regions
    .filter(({ name }) =>
      name.toLowerCase().includes(searchValue.toLowerCase())
    )
    .map(({ id, name, legacyResourceId }) => ({
      label: name,
      queryValue: legacyResourceId,
      isSelected: currentRegion?.id === id,
    }));

  return (
    <DesktopFilterSelectAccordion
      isLoading={isLoading}
      dataTestId={regionTestId}
      queryParam={QUERY.regionId}
      title={t('common.city')}
      value={currentRegion?.name ?? null}
      options={options}
      optionTestId={regionOptionTestId}
      search={
        <S.SearchInput
          $hasBottomMargin
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          placeholder={t('common.search')}
          autoCapitalize="none"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          type="search"
        />
      }
    />
  );
};
